import { HiDocumentReport } from 'react-icons/hi';
import { RenderTiles } from '../../../components/common';
import ChildHeader from '../../../components/ui/ChildHeader';

export type tilesType = {
  sNo: number;
  link: string;
  isLink: boolean;
  isIcon: boolean;
  clauseNo?: string | number;
  p: string;
  span: string;
  icon?: any;
  style?: {};
}[];
const tiles = [
  {
    sNo: 1,
    isLink: false,
    link: '/common/tniTrainingPlanTiles',
    clauseNo: 5,
    icon: <HiDocumentReport size="5rem" color="#135089" />,
    p: 'STAFF / ASSOCIATE',
    span: 'CALENDARS',
    isIcon: true,
  },
  {
    sNo: 2,
    isLink: false,
    link: '/common/tniCsrPlanTiles',
    clauseNo: 5,
    icon: <HiDocumentReport size="5rem" color="#135089" />,
    p: 'CSR',
    span: 'CALENDAR',
    isIcon: true,
  },
];

const TrainingCalenderTiles = () => {
  return (
    <>
      <ChildHeader text="TRAINING CALENDER" />
      <RenderTiles tilesObj={tiles} height={'100vh'} justify="start" />
    </>
  );
};

export default TrainingCalenderTiles;
